import { Component, inject, OnInit } from '@angular/core';
import { AppInformationService, AuthService, BrewersUnitOfWork } from 'app/core/core.module';
import { JournalEntry } from 'app/core/model/journal-entry';
import { QuickBooksAccount } from 'app/core/model/quick-books-account';
import { confirm } from 'devextreme/ui/dialog';
import { BsModalService } from 'ngx-bootstrap/modal';
import { JournalEntryDialogComponent } from '../journal-entry-dialog/journal-entry-dialog.component';

@Component({
    standalone: false,
    selector: 'app-journal-entry-overview',
    templateUrl: './journal-entry-overview.component.html',
    styleUrl: './journal-entry-overview.component.scss',
})
export class JournalEntryOverviewComponent implements OnInit {
    uow = inject(BrewersUnitOfWork);
    appInfo = inject(AppInformationService);
    auth = inject(AuthService);
    modalService = inject(BsModalService);

    journalEntries: JournalEntry[];
    quickBooksAccounts: QuickBooksAccount[];

    async ngOnInit() {
        await this.appInfo.pleaseWaitShow();
        this.quickBooksAccounts = await this.uow.quickBooksAccounts.whereActive('name');
        await this.getData();
        await this.appInfo.pleaseWaitHide();
    }

    async getData() {
        this.journalEntries = await this.uow.journalEntries.whereActive('journalEntryDate desc, id desc');
    }

    rowDoubleClick(e: any) {
        this.open(e.data);
    }

    async open(journalEntry?: JournalEntry) {
        const modalRef = this.modalService.show(JournalEntryDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                journalEntry: journalEntry,
            },
        });

        modalRef.content?.result.subscribe(async (result) => {
            if (result.success) {
                await this.appInfo.pleaseWaitShow();
                await this.getData();
                await this.appInfo.pleaseWaitHide();
            }
            modalRef.hide();
        });
    }

    async delete(journalEntry: JournalEntry) {
        if (!journalEntry) return;

        let message = 'Are you sure you want to delete this journal entry?';
        if (journalEntry.quickBooksId) message += ' It has been exported, so be sure to delete it from QuickBooks.';
        const success = await confirm(message, this.appInfo.settings.company);
        if (!success) return;

        await this.appInfo.pleaseWaitShow();
        journalEntry.deleted = new Date();
        journalEntry.deletedBy = this.auth.currentUser.userName;
        await this.uow.commit([journalEntry]);
        await this.getData();
        await this.appInfo.pleaseWaitHide();
    }
}
